import React, { useCallback } from "react";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { Markup } from "interweave";
import { useEffect, useRef, useState } from "react";
import QRCode from "react-qr-code";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import noImage from "../../../../assets/images/settings/no-image.png";
import "./Settings.css";
import { serverInfo } from "../../../../App";
import { useContext } from "react";
import { withStyles } from "@material-ui/core/styles";
import { styles } from "../../Home/Pages/AddSuperStar/styles";
import getCroppedImg from "../../Home/Pages/AddSuperStar/cropImage";
import { Modal } from "react-bootstrap";
import Cropper from "react-easy-crop";
import Typography from "@material-ui/core/Typography";
import Slider from "@material-ui/core/Slider";
import { Button } from "@material-ui/core";
import useCoverChange from "../../../../CustomHooks/useCoverChange";
import useProfileChange from "../../../../CustomHooks/useProfileChange";

const Demo = ({classes}) => {
  const { imageCdnUrl } = useContext(serverInfo);
  const history = useHistory();
  const [user, setUser] = useState([]);
  const [starInfo, setStarInfo] = useState([]);
  const [profileImage, setProfileImage] = useState("");
  const [profilePhoto, setProfilePtoto] = useState("");
  const [coverPhoto, setCoverPhoto] = useState("");
  const [coverImage, setCoverImage] = useState("");
  const [passwordMatch, setPasswordMatch] = useState("");
  const [passwordNotMatch, setPasswordNotMatch] = useState("");

  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loading4, setLoading4] = useState(false);

  const [changeIcon, setChange] = useState(false);
  function handleChangeIcon() {
    setChange(!changeIcon);
  }

  const [changeIcon2, setChange2] = useState(false);
  function handleChangeIcon2() {
    setChange2(!changeIcon2);
  }

  const [changeIcon3, setChange3] = useState(false);
  function handleChangeIcon3() {
    setChange3(!changeIcon3);
  }

  const [changeIcon4, setChange4] = useState(false);
  function handleChangeIcon4() {
    setChange4(!changeIcon4);
  }

  const [changeIcon5, setChange5] = useState(false);
  function handleChangeIcon5() {
    setChange5(!changeIcon5);
  }

  // Cover Change
  const [croppedImage, setCroppedImage] = useState(null);
  const [coverDelKey, setCoverDelKey] = useState(null);
  const [coverUrl, coverKey, coverProgress] = useCoverChange(croppedImage, 'profile/superstar/cover', coverDelKey);

  // Profile Change
  const [profileCroppedImage, setProfileCroppedImage] = useState(null);
  const [profileDelKey, setProfileDelKey] = useState(null);
  const [profileUrl, profileKey, profileProgress] = useProfileChange(profileCroppedImage, 'profile/superstar/image', profileDelKey);

  useEffect(() => {
    localStorage.getItem("auth_token") &&
      axios.get(`/api/user_info`).then((res) => {
        if (res.status === 200) {
          setUser(res.data.users);
          setStarInfo(res.data.star_details);
          setProfileImage(
            res.data.users.image !== null
              ? imageCdnUrl + res.data.users.image
              : noImage
          );
          setCoverPhoto(
            res.data.users.cover_photo !== null
              ? imageCdnUrl + res.data.users.cover_photo
              : noImage
          );
        }
      });
  }, []);

  // ✅ Update profile image when profileUrl changes from hook
  useEffect(() => {
    if (profileUrl) {
      setProfileImage(profileUrl);
    }
  }, [profileUrl]);

  // ✅ Update cover photo when coverUrl changes from hook
  useEffect(() => {
    if (coverUrl) {
      setCoverPhoto(coverUrl);
    }
  }, [coverUrl]);

  const fileRef = useRef();
  const filePro = useRef();

  const handleCoverChange = (e) => {
    setCoverImage(e.target.files[0]);
    setCoverPhoto(URL.createObjectURL(e.target.files[0]));
  };

  const handleProfileChange = (e) => {
    setProfilePtoto(e.target.files[0]);
    setProfileImage(URL.createObjectURL(e.target.files[0]));
  };

  const coverSave = () => {
    setLoading1(true);
    const fData = new FormData();
    fData.append("cover_photo", coverKey || coverImage);

    axios.post(`/api/jury/juryUpdateCover/${user.id}`, fData).then((res) => {
      setLoading1(false);
      if (res.data.status == 200) {
        setCoverImage("");
        setCroppedImage(null);
        swal("Success", "Cover photo updated", "success");
      } else {
        swal("Error", "Failed to update cover photo", "error");
      }
    }).catch((err) => {
      setLoading1(false);
      swal("Error", err.message, "error");
    });
  };

  const profileSave = () => {
    setLoading2(true);
    const fData = new FormData();
    fData.append("image", profileKey || profilePhoto);

    axios.post(`/api/jury/juryUpdateProfile/${user.id}`, fData).then((res) => {
      setLoading2(false);
      if (res.data.status == 200) {
        setProfilePtoto("");
        setProfileCroppedImage(null);
        swal("Success", "Profile photo updated", "success");
      } else {
        swal("Error", "Failed to update profile photo", "error");
      }
    }).catch((err) => {
      setLoading2(false);
      swal("Error", err.message, "error");
    });
  };

  const [modalShow, setModalShow] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [profileModalShow, setProfileModalShow] = useState(false);
  const [profileCrop, setProfileCrop] = useState({ x: 0, y: 0 });
  const [profileZoom, setProfileZoom] = useState(1);
  const [profileCroppedAreaPixels, setProfileCroppedAreaPixels] = useState(null);

  const handleProfileClose = () => setProfileModalShow(false);
  const handleShow = () => setModalShow(true);
  const handleClose = () => setModalShow(false);
  const handleProfileShow = () => setProfileModalShow(true);

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const profileOnCropComplete = useCallback(
    (croppedArea, croppedAreaPixels) => {
      setProfileCroppedAreaPixels(croppedAreaPixels);
    },
    []
  );

  // ✅ Convert data URL to Blob
  const dataUrlToBlob = (dataUrl, fileName) => {
    return new Promise((resolve) => {
      fetch(dataUrl).then(res => res.blob()).then(blob => {
        const file = new File([blob], fileName, { type: blob.type });
        resolve(file);
      });
    });
  };

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImg = await getCroppedImg(
        coverPhoto,
        croppedAreaPixels,
      );
      // ✅ Convert data URL to Blob and pass to hook
      const croppedBlob = await dataUrlToBlob(croppedImg, `cover_${Date.now()}.png`);
      setCroppedImage(croppedBlob);
      setModalShow(false);
    } catch (e) {
      console.error(e);
    }
  }, [coverPhoto, croppedAreaPixels]);

  const profileShowCroppedImage = useCallback(async () => {
    try {
      const profileCroppedImg = await getCroppedImg(
        profileImage,
        profileCroppedAreaPixels
      );
      // ✅ Convert data URL to Blob and pass to hook
      const profileCroppedBlob = await dataUrlToBlob(profileCroppedImg, `profile_${Date.now()}.png`);
      setProfileCroppedImage(profileCroppedBlob);
      setProfileModalShow(false);
    } catch (e) {
      console.error(e);
    }
  }, [profileImage, profileCroppedAreaPixels]);

  const [infoInput, setInfoInput] = useState({
    id: user.id,
    first_name: "",
    last_name: "",
    mail: "",
    phone: "",
    password: "",
    confirm_password: "",
    error_list: [],
  });
  const [passInput, setPassInput] = useState({
    current_password: "",
    new_password: "",
    password_confirm: "",
    error_list: [],
  });

  const handleInput = (e) => {
    const { name, value } = e.target;
    setInfoInput((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const handlePassword = (e) => {
    const { name, value } = e.target;
    setPassInput((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const changePassword = (e) => {
    e.preventDefault();
    setLoading3(true);
    const fData = new FormData();

    fData.append("current_password", passInput.current_password);
    fData.append("new_password", passInput.new_password);
    fData.append("password_confirm", passInput.password_confirm);

    if (passInput.new_password == passInput.password_confirm) {
      axios.get("/sanctum/csrf-cookie").then((response) => {
        axios.post(`/api/user_info_update/star_admin`, fData).then((res) => {
          setLoading3(false);
          if (res.data.status === 200) {
            swal("Info Updated", res.data.message, "success");
            setPasswordNotMatch("");
          } else {
            swal("Something Wrong", res.data.message, "error");
          }
        });
      });
    } else {
      swal("Info", "Password Not Matched", "error");
      setPasswordNotMatch("Password not match");
    }
  };

  const submitInfo = (e) => {
    e.preventDefault();
    setLoading4(true);
    const fData = new FormData();

    fData.append("first_name", infoInput.first_name);
    fData.append("last_name", infoInput.last_name);
    fData.append("email", infoInput.email);
    fData.append("phone", infoInput.phone);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.post(`/api/user_info_update/star_admin_info`, fData).then((res) => {
        setLoading4(false);
        if (res.data.status === 200) {
          setPasswordMatch("");
          swal("Info Updated", res.data.message, "success");
        } else {
          swal("Something Wrong", res.data.message, "error");
        }
      });
    });
  };

  return (
    <>
      <div className="row card-bg mx-1 py-3">
        <div className="col-md-12 custom-position-img">
          <div className="profile-container">
            {croppedImage ? (
              <img
                src={URL.createObjectURL(croppedImage)}
                className="img-fluid profile-cover mx-auto"
                alt="cover_photo"
              />
            ) : (
              <img
                src={coverPhoto ? coverPhoto : noImage}
                className="img-fluid profile-cover"
                alt="cover_photo"
              />
            )}
            {/* ✅ Show progress indicator */}
            {coverProgress > 0 && coverProgress < 100 && (
              <div className="progress" style={{ height: "5px" }}>
                <div 
                  className="progress-bar bg-info" 
                  style={{ width: `${coverProgress}%` }}
                />
              </div>
            )}
          </div>

          {croppedImage && (
            <>
              {loading1 ? (
                <button
                  className="btn btn-warning cover-po me-3"
                  onClick={coverSave}
                  disabled
                >
                  <i className="fas fa-spinner fa-pulse"></i> Saving...
                </button>
              ) : (
                <button
                  className="btn btn-warning cover-po me-3"
                  onClick={coverSave}
                >
                  <i className="far fa-save mx-1"></i> Save
                </button>
              )}
            </>
          )}

          <button className="bottomright" onClick={handleShow}>
            <i className="fa-solid fa-camera"></i>
          </button>

          <Modal
            show={modalShow}
            onHide={handleClose}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <div>
                <div className={classes.cropContainer}>
                  <Cropper
                    image={coverPhoto}
                    crop={crop}
                    zoom={zoom}
                    aspect={1250 / 450}
                    onCropChange={setCrop}
                    onCropComplete={onCropComplete}
                    onZoomChange={setZoom}
                  />
                </div>
                <div className={classes.controls}>
                  <div className={classes.sliderContainer}>
                    <Typography
                      variant="overline"
                      classes={{ root: classes.sliderLabel }}
                    >
                      Zoom
                    </Typography>
                    <Slider
                      value={zoom}
                      min={1}
                      max={3}
                      step={0.1}
                      aria-labelledby="Zoom"
                      classes={{ root: classes.slider }}
                      onChange={(e, zoom) => setZoom(zoom)}
                    />
                  </div>

                  <input
                    accept="image/*"
                    ref={fileRef}
                    onChange={handleCoverChange}
                    multiple={false}
                    type="file"
                    hidden
                  />
                  <Button
                    onClick={showCroppedImage}
                    variant="contained"
                    color="primary"
                    classes={{ root: classes.cropButton }}
                  >
                    Save
                  </Button>
                  <Button
                    onClick={() => fileRef.current.click()}
                    variant="contained"
                    color="primary"
                    classes={{ root: classes.cropButton }}
                  >
                    Choose
                  </Button>
                </div>
              </div>
            </Modal.Body>
          </Modal>

          <div className="profile-div mb-5">
            <div className="profile-photo">
              <div className="d-flex justify-content-center">
                {profileCroppedImage ? (
                  <img
                    src={URL.createObjectURL(profileCroppedImage)}
                    alt="profile"
                    className="img-fluid profile-img-pro"
                  />
                ) : (
                  <img
                    src={profileImage ? profileImage : noImage}
                    alt="profile"
                    className="img-fluid profile-img-pro"
                  />
                )}
              </div>

              {/* ✅ Show progress indicator */}
              {profileProgress > 0 && profileProgress < 100 && (
                <div className="progress" style={{ height: "5px", width: "100px", margin: "0 auto" }}>
                  <div 
                    className="progress-bar bg-success" 
                    style={{ width: `${profileProgress}%` }}
                  />
                </div>
              )}

              <button
                className="profile-pic-cam cam-po"
                onClick={handleProfileShow}
              >
                <i className="fa-solid fa-camera"></i>
              </button>

              {profileCroppedImage && (
                <>
                  {loading2 ? (
                    <button className="profile-pic-save rounded-3 mb-2" disabled>
                      <i className="fas fa-spinner fa-pulse"></i> Saving...
                    </button>
                  ) : (
                    <button
                      className="profile-pic-save cover-po rounded-3 mb-2"
                      onClick={profileSave}
                    >
                      Save
                    </button>
                  )}
                </>
              )}

              <Modal
                show={profileModalShow}
                onHide={handleProfileClose}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
              >
                <Modal.Body>
                  <div>
                    <div className={classes.cropContainer}>
                      <Cropper
                        image={profileImage}
                        crop={profileCrop}
                        zoom={profileZoom}
                        aspect={720 / 720}
                        onCropChange={setProfileCrop}
                        onCropComplete={profileOnCropComplete}
                        onZoomChange={setProfileZoom}
                      />
                    </div>
                    <div className={classes.controls}>
                      <div className={classes.sliderContainer}>
                        <Typography
                          variant="overline"
                          classes={{ root: classes.sliderLabel }}
                        >
                          Zoom
                        </Typography>
                        <Slider
                          value={profileZoom}
                          min={1}
                          max={3}
                          step={0.1}
                          aria-labelledby="Zoom"
                          classes={{ root: classes.slider }}
                          onChange={(e, profileZoom) => setProfileZoom(profileZoom)}
                        />
                      </div>

                      <input
                        accept="image/*"
                        ref={filePro}
                        onChange={handleProfileChange}
                        multiple={false}
                        type="file"
                        hidden
                      />
                      <Button
                        onClick={profileShowCroppedImage}
                        variant="contained"
                        color="primary"
                        classes={{ root: classes.cropButton }}
                      >
                        Save
                      </Button>
                      <Button
                        onClick={() => filePro.current.click()}
                        variant="contained"
                        color="primary"
                        classes={{ root: classes.cropButton }}
                      >
                        Choose
                      </Button>
                    </div>
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>

        <center className="user-name-top">
          <div className="text-light fw-bold adm-name">
            {user.first_name} {user.last_name}
          </div>
          <small className="user-name-admin">{user?.username}</small>
        </center>

        {user.user_type == "star" ? (
          <>
            <div className="co-md-6 my-4">
              <h5 className="text-warning fw-bold">Terms & Conditions</h5>
              <p className="text-light text-justify">
                <Markup content={starInfo?.terms_and_condition} />
              </p>
            </div>
            <div className="co-md-6 my-4">
              <h5 className="text-warning fw-bold">
                QR Code : {starInfo?.qr_code}
              </h5>
              <p className="text-light text-justify">
                <QRCode value={`${starInfo?.qr_code}`} />
              </p>
            </div>
          </>
        ) : null}

        <div className="row mt-5">
          <div className="col-md-4 mb-3 ">
            <div className="custom-card-profile">
              <div className="text-light p-2 px-3 fw-bold">
                Personal Information
              </div>
            </div>

            <div className="custom-card-profile-down px-3 p-2">
              <form>
                <div className="form-group mb-2">
                  <label className="text-light pb-1">Name</label>
                  <input
                    disabled
                    type="text"
                    className="form-control custom-pro-input"
                    placeholder={user.first_name + " " + user.last_name}
                  />
                </div>
                <div className="form-group mb-2">
                  <label className="text-light pb-1">User Name</label>
                  <input
                    disabled
                    type="text"
                    className="form-control custom-pro-input"
                    placeholder={user.username}
                  />
                </div>

                <div className="form-group mb-2">
                  <label className="text-light pb-1">Mail</label>
                  <input
                    disabled
                    type="email"
                    className="form-control custom-pro-input"
                    placeholder={user.email}
                  />
                </div>

                <div className="form-group mb-2">
                  <label className="text-light pb-1">Phone</label>
                  <input
                    disabled
                    type="text"
                    className="form-control custom-pro-input"
                    placeholder={user.phone}
                  />
                </div>
              </form>
            </div>
          </div>

          <div className="col-md-4 mb-3 ">
            <div className="custom-card-profile">
              <div className="text-light p-2 px-3 fw-bold">Edit Name</div>
            </div>

            <div className="custom-card-profile-down px-3 p-2">
              <form onSubmit={submitInfo}>
                <div className="form-group mb-2">
                  <label className="text-light pb-1">First Name</label>
                  <input
                    type="text"
                    name="first_name"
                    onChange={handleInput}
                    value={infoInput.first_name}
                    className="form-control custom-pro-input"
                    placeholder={user?.first_name}
                  />
                </div>
                <div className="form-group mb-2">
                  <label className="text-light pb-1">Last Name</label>
                  <input
                    type="text"
                    name="last_name"
                    onChange={handleInput}
                    value={infoInput.last_name}
                    className="form-control custom-pro-input"
                    placeholder={user?.last_name}
                  />
                </div>

                <div className="form-group mb-2">
                  <label className="text-light pb-1">Mail</label>
                  <input
                    type="email"
                    name="email"
                    onChange={handleInput}
                    value={infoInput.email}
                    className="form-control custom-pro-input"
                    placeholder={user?.email}
                  />
                </div>

                <div className="form-group mb-2">
                  <label className="text-light pb-1">Phone</label>
                  <input
                    type="text"
                    name="phone"
                    onChange={handleInput}
                    value={infoInput.phone}
                    className="form-control custom-pro-input"
                    placeholder={user?.phone}
                  />
                </div>

                <div className="form-group mb-2 mt-4">
                  {loading4 ? (
                    <button className="btn form-control fw-bold custom-pro-input-x mt-2" disabled>
                      <i className="fas fa-spinner fa-pulse"></i> Updating...
                    </button>
                  ) : (
                    <button
                      type="submit"
                      className="btn form-control fw-bold custom-pro-input-x mt-2"
                    >
                      Update Info
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>

          <div className="col-md-4 mb-3 ">
            <div className="custom-card-profile">
              <div className="text-light p-2 px-3 fw-bold">Edit Password</div>
            </div>

            <div className="custom-card-profile-down px-3 p-2">
              <form onSubmit={changePassword}>
                <div className="form-group mb-2 passWordEye">
                  <label className="text-light pb-1">
                    Current Password
                  </label>
                  <input
                    required
                    type={changeIcon ? `text` : `password`}
                    name="current_password"
                    onChange={handlePassword}
                    value={passInput.current_password}
                    className="form-control custom-pro-input"
                    placeholder={"password"}
                  />
                  <span onClick={handleChangeIcon} className="eye-icons">
                    <FontAwesomeIcon icon={changeIcon ? faEye : faEyeSlash} />
                  </span>
                </div>

                <div className="form-group passWordEye mb-2">
                  <label className="text-light pb-1">
                    New Password
                  </label>
                  <input
                    required
                    type={changeIcon2 ? `text` : `password`}
                    name="new_password"
                    onChange={handlePassword}
                    value={passInput.new_password}
                    className="form-control custom-pro-input"
                    placeholder={"**************"}
                  />
                  <span onClick={handleChangeIcon2} className="eye-icons">
                    <FontAwesomeIcon icon={changeIcon2 ? faEye : faEyeSlash} />
                  </span>
                </div>

                <div className="form-group passWordEye mb-2">
                  <label className="text-light pb-1">
                    Confirm Password
                  </label>
                  <input
                    required
                    type={changeIcon3 ? `text` : `password`}
                    name="password_confirm"
                    onChange={handlePassword}
                    value={passInput.password_confirm}
                    className="form-control custom-pro-input"
                    placeholder={"**************"}
                  />
                  <span onClick={handleChangeIcon3} className="eye-icons">
                    <FontAwesomeIcon icon={changeIcon3 ? faEye : faEyeSlash} />
                  </span>
                </div>

                <div className="form-group mb-2 mt-4">
                  {loading3 ? (
                    <button className="btn form-control fw-bold custom-pro-input-x mt-2" disabled>
                      <i className="fas fa-spinner fa-pulse"></i> Updating...
                    </button>
                  ) : (
                    <button
                      type="submit"
                      className="btn form-control fw-bold custom-pro-input-x mt-2"
                    >
                      Update
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const Settings = withStyles(styles)(Demo);
export default Settings;